import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import React from "react";
import { FormattedNumber, injectIntl } from "react-intl";
import Moment from "react-moment";
import * as constants from "../../util/constants";
import ButtonClose from "./ButtonClose";
import FieldDate from "./FieldDate";
import Propertii from "./Propertii";
import Spinner from "./Spinner";
import Table from "./Table";
import Modal from "./Modal";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import FieldProperty from "./FieldProperty";
import PaymentFlow from "./Payment";

class ReportCreditReportingSubscriptions extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {

            creditReport: {},

            creditReportList: {
                page: '',
                recordsPerPage: '',
                totalPages: '',
                totalRecordCount: '',
                records: [
                    {}
                ]
            },

            startDate: moment().subtract(30, 'days').format('YYYY-MM-DD[T]hh:mm:ssZZ'),
            endDate: null,

            parameters: {
                settledOnly: '',
                propertyId: null
            },

            propertyList: [],
            selectedProperty: null,

            validationList: [],

        };

        this.searchCreditReports = this.searchCreditReports.bind(this);
        this.filterCreditReports = this.filterCreditReports.bind(this);
        this.downloadCreditReports = this.downloadCreditReports.bind(this);
        this.viewCreditReport = this.viewCreditReport.bind(this);
        this.searchProperties = this.searchProperties.bind(this);
        this.transformDataForPDF = this.transformDataForPDF.bind(this);
        this.getHeaderForPDF = this.getHeaderForPDF.bind(this);
    }

    /**
     * Fetch the list of related properties and credit reporting subscriptions upon mounting of the component.
     */
    componentDidMount() {

        let filter = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            parameters: {
                propertyId: this.state.parameters.propertyId
            }
        };

        this.searchProperties();
        this.searchCreditReports(1, 25, filter);
    }

    /**
     * View the detailed information of a credit reporting subscription by initializing the creditReport view modal.
     *
     * @param creditReport - The creditReport model to view.
     */
    viewCreditReport(creditReport) {

        this.setState(prevState => ({
            ...prevState,
            creditReport: creditReport
        }));

        $('#creditReport').modal('show');
    }

    /**
     * Update the data table of credit reports.
     *
     * @param page - The page to display.
     * @param recordsPerPage - The amount of records to display on each page.
     * @param filter - The filters to apply to the search.
     */
    searchCreditReports(page, recordsPerPage, filter) {

        this.setState({
            spinner: true
        });

        axios.post(`${constants.REACT_APP_HOST_API_URL}/export/${this.props.companyId}/export_CREDIT_REPORTING_SUBSCRIPTIONS?recordsPerPage=${recordsPerPage}&page=${page}`, filter, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState(prevState => ({
                ...prevState,
                spinner: false,
                creditReportList: response.data,
            }));
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Apply the available search filters on the credit report list and perform a new search.
     *
     * @param event - The event container.
     */
    filterCreditReports(event) {

        if(event != null) {
            event.preventDefault();
        }

        let filter = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            parameters: {

                propertyId: this.state.parameters.propertyId
            }
        };

        if(this.state.fromDate != null) {
            filter.startDate = this.state.startDate;
        }

        if(this.state.endDate != null) {
            filter.endDate = this.state.endDate;
        }

        this.searchCreditReports(1, 25, filter);
    }

    /**
     * Search for a list of all available properties for filtering.
     */
    searchProperties() {

        axios.post(`${constants.REACT_APP_HOST_API_URL}/property/search`, {
            orderBy: 'ASC',
            orderByFields: ['createDate'],
            conditionList: [
                {
                    type: 'STRING',
                    logicalOperator: 'OR',
                    openBrackets: null,
                    closeBrackets: null,
                    fieldName: 'companyId',
                    operator: 'EQUALS',
                    fieldValue: this.props.companyId
                },
                {
                    type: 'STRING',
                    logicalOperator: 'OR',
                    openBrackets: null,
                    closeBrackets: null,
                    fieldName: 'c.parentId',
                    operator: 'EQUALS',
                    fieldValue: this.props.companyId
                }
            ],
            joins: {
                c: {
                    targetRecordType: 'TYPE_COMPANY',
                    joinField: 'companyId',
                    alias: 'c',
                },
            }
        }, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState(prevState => ({
                ...prevState,
                propertyList: response.data.records
            }));
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Show Modal to confirm download format
     *
     * @param event - The event container.
     */
    downloadCreditReports(event) {

        event.preventDefault();

        $("#download-format-confirm").modal("show")
    }

    /**
     * Download the credit reporting subscriptions report in CSV format. The downloaded file is based on the filters set by the user.
     *
     * @param event - The event container.
     */
    downloadCreditReportsCSV() {

        axios.post(`${constants.REACT_APP_HOST_API_URL}/export/${this.props.companyId}/export_CREDIT_REPORTING_SUBSCRIPTIONS/download`, {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            parameters: {
                propertyId: this.state.parameters.propertyId
            }
        }, {
            responseType: 'arraybuffer',
            headers: this.generateRequestHeaders()
        }).then(response => {

            const FileDownload = require('js-file-download');

            let responseHeader = response.request.getResponseHeader('Content-Disposition');
            let startIndex = responseHeader.indexOf("filename=") + 24;
            let endIndex = responseHeader.length - 1;
            let filename = responseHeader.substring(startIndex, endIndex);

            FileDownload(response.data, filename);

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Download the credit reporting subscriptions report in PDF format. The downloaded file is based on the filters set by the user.
     *
     *
     */
    downloadCreditReportsPDF() {

        axios.post(`${constants.REACT_APP_HOST_API_URL}/export/${this.props.companyId}/export_CREDIT_REPORTING_SUBSCRIPTIONS/download`, {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            parameters: {
                propertyId: this.state.parameters.propertyId
            }
        }, {
            responseType: 'string',
            headers: this.generateRequestHeaders()
        }).then(response => {

            const dataTransformed = this.transformDataForPDF(response.data);

            let columnStyles = {};
            let widthPDF;

            if (dataTransformed.headerForPDF.length === 27){
                columnStyles = {
                    0: { cellWidth : 35 },
                    1: { cellWidth : 35 },
                    2: { cellWidth : 30 },
                    3: { cellWidth : 20 },
                    4: { cellWidth : 30 },
                    5: { cellWidth : 20 },
                    6: { cellWidth : 40 },
                    7: { cellWidth : 40 },

                    8: { cellWidth : 40 },
                    9: { cellWidth : 30 },
                    10: { cellWidth : 30 },
                    11: { cellWidth : 30 },
                    12: { cellWidth : 20 },
                    13: { cellWidth : 30 },
                    14: { cellWidth : 20 },
                    15: { cellWidth : 25 },
                    16: { cellWidth : 20 },
                    17: { cellWidth : 20 },
                    18: { cellWidth : 20 },

                    19: { cellWidth : 40 },
                    20: { cellWidth : 30 },
                    21: { cellWidth : 20 },
                    22: { cellWidth : 20 },
                    23: { cellWidth : 20 },
                    24: { cellWidth : 50 },
                    25: { cellWidth : 40 },
                    26: { cellWidth : 50 },
                }
                widthPDF = 835
            } else{
                columnStyles = {
                    0: { cellWidth : 40 },
                    1: { cellWidth : 40 },
                    2: { cellWidth : 30 },
                    3: { cellWidth : 20 },
                    4: { cellWidth : 30 },
                    5: { cellWidth : 20 },
                    6: { cellWidth : 40 },
                    7: { cellWidth : 30 },

                    8: { cellWidth : 30 },
                    9: { cellWidth : 30 },
                    10: { cellWidth : 30 },
                    11: { cellWidth : 30 },
                    12: { cellWidth : 20 },
                    13: { cellWidth : 30 },
                    14: { cellWidth : 20 },
                    15: { cellWidth : 25 },
                    16: { cellWidth : 20 },
                    17: { cellWidth : 20 },
                    18: { cellWidth : 20 },

                    19: { cellWidth : 40 },
                    20: { cellWidth : 30 },
                    21: { cellWidth : 20 },
                    22: { cellWidth : 20 },
                    23: { cellWidth : 20 },
                    24: { cellWidth : 50 },
                    25: { cellWidth : 40 },
                }
                widthPDF = 775
            }

            const doc = new jsPDF('landscape', 'mm', [297, widthPDF]);

            doc.setFontSize(12);
            doc.text('Credit Reporting Subscriptions Report', 14, 10)

            doc.autoTable({
                head: [dataTransformed?.headerForPDF],
                body: dataTransformed?.bodyForPDF,
                horizontalPageBreak:false,
                theme: 'grid',
                headStyles:{
                    fillColor: '#e9ecef',
                    fontStyle: 'bold',
                    textColor: '#212529',
                    fontSize: '9',
                },
                bodyStyles:{
                    textColor: '#212529',
                    fontSize: '9',
                    minCellHeight: '10',
                    valign:'middle',
                },
                columnStyles: columnStyles
            });
            doc.save('Credit Reporting Subscriptions Report.pdf')

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Transform data to get header and body to pass into jsPDF
     *
     * @param data - The data returned by the endpoint to be converted into PDF.
     */
    transformDataForPDF(data) {
        const rows = data.split('\n');
        let headerForPDF = '';
        let dataForPDF = {};
        let bodyForPDF = [[]];

        if(rows.length >0){
            headerForPDF = this.getHeaderForPDF(rows[0]);
            bodyForPDF = this.getBodyForPDF(rows);
            dataForPDF ={
                headerForPDF : headerForPDF,
                bodyForPDF : bodyForPDF,
            }
        }

        return dataForPDF;

    }

    /**
     * Get the header to be passed into jsPDF
     *
     * @param headerData - The data returned by the endpoint to be converted into PDF.
     */
    getHeaderForPDF(headerData) {
        const headersToBeCleaned = headerData.split("\"");
        const headers = headersToBeCleaned.filter( header => header !== ',' && header !== '' && header !== '\r');

        return headers;

    }

    /**
     * Get the body to be passed into jsPDF
     *
     * @param data - The data returned by the endpoint to be converted into PDF.
     */
    getBodyForPDF(data) {
        let bodyToBeCleaned = [];
        let rowAux = [];
        let body = [];

        for (let i=1; i < data.length; i++){
            rowAux = data[i].split("\"");
            rowAux.shift();
            bodyToBeCleaned.push(rowAux);
            body[i-1] = bodyToBeCleaned[i-1].filter( row => row !== ',' && row !== '\r');
        }
        return body;
    }

    /**
     * Render the component.
     *
     * @returns {*} - The completed credit reporting subscriptions report component.
     */
    render() {

        $(function() {
            $('[data-toggle="tooltip"]').tooltip()
        });

        return (
            <React.Fragment>

                <Spinner visible={this.state.spinner} />

                <div className="card">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col">
                                Credit Report Subscriptions
                            </div>
                            <div className="col text-right">
                                <div className="btn btn-primary btn-sm" onClick={(event) => this.downloadCreditReports(event)}>
                                    <FontAwesomeIcon icon={['fas', 'download']} className="fa-fw" /> Download Report
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-header gotham border-top py-3 bg-secondary">
                        <form onSubmit={this.filterCreditReports} autoComplete="off">
                            <div className="media">

                                <div className="media-body align-self-center mr-3">
                                    <FieldDate id="startDate" labelColumns="0"
                                               fieldColumns="12" parent={this}
                                               value={this.state.startDate}
                                               selectsRange={true} startDate={this.state.startDate}
                                               endDate={this.state.endDate}/>
                                </div>
                                <div className="media-body align-self-center mr-3">
                                    <FieldProperty id="propertyId" label="Property" model="parameters" fieldColumns="12"
                                                   labelClass="d-none" labelColumns="0"
                                                   value={this.state.selectedProperty} parent={this}
                                                   options={this.state.propertyList} allPropertiesOption={true} />
                                </div>
                                <div className="align-self-center text-right">
                                    <button type="submit" className="btn btn-secondary btn-sm btn-block mb-0">
                                        <FontAwesomeIcon icon={['fas', 'search']} className="fa-fw"/> Search
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    {this.props.userType ==='TYPE_ADMIN' &&
                        <Table tableClass="table-bordered tabl-hover table-responsive"
                               columns={{
                                   name: 'Name',
                                   property: 'Property',
                                   termInMonths: 'Term in Months',
                                   startDate: 'Start Date',
                                   endDate: 'End Date',
                                   amount: 'Amount',
                                   status: 'Status',
                                   refund: 'Refund'
                               }}
                               headerClass=""
                               data={this.state.creditReportList}
                               filters={{
                                   startDate: this.state.startDate,
                                   endDate: this.state.endDate,
                                   parameters: {

                                       propertyId: this.state.parameters.propertyId
                                   }
                               }}
                               sortEnabled={false}
                               recordsEnabled={true}
                               paginationEnabled={true}
                               updateFunction={this.searchCreditReports}>
                            <tbody>
                            {this.state.creditReportList.records.map((data, key) => {
                                return(
                                    <tr key={key} onClick={() => this.viewCreditReport(data)} className="c-pointer">
                                        <td>
                                            <div className="">
                                                {data.firstName} {data.lastName}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.property}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.termInMonths}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.startDate && (
                                                    <Moment format='YYYY-MM-DD HH:mm'>
                                                        {data.startDate}
                                                    </Moment>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.endDate && (
                                                    <Moment format='YYYY-MM-DD HH:mm'>
                                                        {data.endDate}
                                                    </Moment>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.amount}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.status}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.refund}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    }

                    {this.props.userType !=='TYPE_ADMIN' &&
                        <Table tableClass="table-bordered tabl-hover table-responsive"
                               columns={{
                                   name: 'Name',
                                   property: 'Property',
                                   termInMonths: 'Term in Months',
                                   startDate: 'Start Date',
                                   endDate: 'End Date',
                                   amount: 'Amount',
                                   status: 'Status',
                                   cancelled: 'Cancellation Date',
                                   refund: 'Refund'
                               }}
                               minColumnWidths={[
                                   '120px',
                                   '200px',
                                   '50px',
                                   '150px',
                                   '150px',
                                   '100px',
                                   '50px',
                                   '150px',
                                   '100px'
                               ]}
                               headerClass=""
                               data={this.state.creditReportList}
                               filters={{
                                   startDate: this.state.startDate,
                                   endDate: this.state.endDate,
                                   parameters: {

                                       propertyId: this.state.parameters.propertyId
                                   }
                               }}
                               sortEnabled={false}
                               recordsEnabled={true}
                               paginationEnabled={true}
                               updateFunction={this.searchCreditReports}>
                            <tbody>
                            {this.state.creditReportList.records.map((data, key) => {
                                return(
                                    <tr key={key} onClick={() => this.viewCreditReport(data)} className="c-pointer">
                                        <td>
                                            <div className="">
                                                {data.firstName} {data.lastName}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.property}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.termInMonths}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.startDate && (
                                                    <Moment format='YYYY-MM-DD HH:mm'>
                                                        {data.startDate}
                                                    </Moment>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.endDate && (
                                                    <Moment format='YYYY-MM-DD HH:mm'>
                                                        {data.endDate}
                                                    </Moment>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.amount}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.status}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.cancelled && (
                                                    <Moment format='YYYY-MM-DD HH:mm'>
                                                        {data.cancelled}
                                                    </Moment>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {data.refund}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    }
                </div>

                <div className="modal fade" id="creditReport" tabIndex="-1" role="dialog" aria-labelledby="transaction-label" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-md" role="document">
                        <div className="modal-content shadow">
                            <div className="modal-header bg-dark text-white">
                                <h5 className="modal-title">
                                    <div className="">
                                        Credit Report Subscription
                                    </div>
                                </h5>
                                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                    <FontAwesomeIcon icon={['fas', 'times']} className="fa-fw va-b mr-2" />
                                </button>
                            </div>
                            {this.props.userType ==='TYPE_ADMIN' &&
                                <div className="modal-body modal-body-table">
                                    <table className="table mb-0">
                                        <tbody>
                                        <tr className="small">
                                            <td className="">
                                                First Name
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.firstName}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Last Name
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.lastName}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Property
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.property}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Term In Months
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.termInMonths}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Start Date
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport?.startDate && (
                                                        <Moment format='YYYY-MM-DD HH:mm '>
                                                            {this.state.creditReport.startDate}
                                                        </Moment>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                End Date
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport?.endDate && (
                                                        <Moment format='YYYY-MM-DD HH:mm '>
                                                            {this.state.creditReport.endDate}
                                                        </Moment>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Amount
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.amount}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Paid By Company
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.paidByCompany}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Status
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.status}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Cancellation Date
                                            </td>
                                            <td className="text-right">
                                                {this.state.creditReport?.cancelled && (
                                                    <Moment format='YYYY-MM-DD HH:mm '>
                                                        {this.state.creditReport.cancelled}
                                                    </Moment>
                                                )}
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Payment Status
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.paymentStatus}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Refund
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.refund}
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            }
                            {this.props.userType !=='TYPE_ADMIN' &&
                                <div className="modal-body modal-body-table">
                                    <table className="table mb-0">
                                        <tbody>
                                        <tr className="small">
                                            <td className="">
                                                First Name
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.firstName}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Last Name
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.lastName}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Property
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.property}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Term In Months
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.termInMonths}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Start Date
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport?.startDate && (
                                                        <Moment format='YYYY-MM-DD HH:mm '>
                                                            {this.state.creditReport.startDate}
                                                        </Moment>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                End Date
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport?.endDate && (
                                                        <Moment format='YYYY-MM-DD HH:mm '>
                                                            {this.state.creditReport.endDate}
                                                        </Moment>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Amount
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.amount}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Status
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.status}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Cancellation Date
                                            </td>
                                            <td className="text-right">
                                                {this.state.creditReport?.cancelled && (
                                                 <Moment format='YYYY-MM-DD HH:mm '>
                                                     {this.state.creditReport.cancelled}
                                                 </Moment>
                                                )}
                                            </td>
                                        </tr>
                                        <tr className="small">
                                            <td className="">
                                                Refund
                                            </td>
                                            <td className="text-right">
                                                <div className="">
                                                    {this.state.creditReport.refund}
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            }
                            <div className="modal-footer d-block text-center bg-secondary rounded-bottom">
                                <ButtonClose />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal  id="download-format-confirm" theme="primary" iconType="fas" iconName="file-spreadsheet"
                        body="What format do you want to download the report?" title="Download Format Confirmation">

                    <button type="button" className="btn btn-outline-primary btn-lg" data-dismiss="modal" onClick={() => this.downloadCreditReportsCSV()}>
                        CSV Format
                    </button>
                    <button onClick={() => this.downloadCreditReportsPDF()} className="btn btn-outline-primary btn-lg" data-dismiss="modal">
                        PDF Format
                    </button>
                </Modal>

            </React.Fragment>
        );
    }
}

export default injectIntl(ReportCreditReportingSubscriptions);
